import React from 'react';

import { TabNavigatorContext } from './TabNavigatorContext';

export function TabNavigator(props) {
  const { children, index = 0 } = props;

  const tabNavigatorStateAndDispatch = React.useState(index);

  return (
    <TabNavigatorContext.Provider value={tabNavigatorStateAndDispatch}>
      {children}
    </TabNavigatorContext.Provider>
  );
}
